







































import Loader from '@/contexts/frontend/Loader.vue'

export default {
  components: {
    loader: Loader
  },
  props: {
    clientId: String,
    teamId: String
  },
  data: function() {
    return {
      team: {
        id: '',
        slug: '',
        name: ''
      },
      loading: false
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .GetTeam(this.teamId)
      .then(result => (this.team = result[0]))
      .finally(() => (this.loading = false))
  },
  methods: {
    deleteTeam() {
      this.$api.clientAdmin
        .DeleteTeam(this.teamId)
        .then(() => this.$router.push({ name: 'settings-teams-list' }))
    }
  }
}
